import {
  getExaminerCitationsDetails,
  generateSearchQueries,
} from "services/project";

// Session caches: the walkthrough prefetch, menu clicks, modal self-fetches and
// repeat opens all share one in-flight/settled request per patent.
const examinerCitationsCache: Record<string, Promise<any>> = {};
export const cachedExaminerCitations = (
  patentNumber: string,
  s3Path: string,
  projectId: any,
  teamId: string
) => {
  const key = `${projectId}:${patentNumber}`;
  if (!examinerCitationsCache[key]) {
    examinerCitationsCache[key] = getExaminerCitationsDetails(
      patentNumber,
      s3Path,
      projectId,
      teamId
    ).catch((e) => {
      delete examinerCitationsCache[key];
      throw e;
    });
  }
  return examinerCitationsCache[key];
};

const searchQueriesCache: Record<string, Promise<any>> = {};
export const cachedSearchQueries = (s3Path: string, patentId: string) => {
  if (!searchQueriesCache[patentId]) {
    searchQueriesCache[patentId] = generateSearchQueries(s3Path, patentId).catch(
      (e) => {
        delete searchQueriesCache[patentId];
        throw e;
      }
    );
  }
  return searchQueriesCache[patentId];
};
